import React, { useState } from 'react'

import get from 'lodash/get'

import applicationConstants from '../../../utils/constants/application'

export default function CompanyLogo(props) {
  const url = get(props, 'url')
  const [imageErrored, setImageErrored] = useState(false)

  return typeof url !== 'string' || imageErrored ? (
    <img
      src={applicationConstants.building_icon_url}
      alt="company logo"
      className="company-logo"
      style={{ margin: '0 auto', height: '50px' }}
    />
  ) : (
    <img
      className="mt-3"
      style={{ maxWidth: '100%' }}
      src={url}
      alt="Company Logo"
      onError={() => setImageErrored(true)}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/ui/CompanyLogo/index.js